import React, { memo } from 'react';
import { FilterSelect } from './FilterSelect';
import { FilterMultiSelect } from './FilterMultiSelect';
import { FilterSearch } from './FilterSearch';
import { FilterDateRange } from './FilterDateRange';
import { FilterNumberRange } from './FilterNumberRange';
import { FilterBoolean } from './FilterBoolean';
import type {
  FilterConfig,
  FilterValue,
  DateRangeValue,
  NumberRangeValue
} from '../FilterPanel.types';

interface FilterItemProps {
  config: FilterConfig;
  value: FilterValue;
  onChange: (value: FilterValue) => void;
  compact?: boolean;
}

function FilterItemComponent({ config, value, onChange, compact }: FilterItemProps): React.ReactElement {
  switch (config.type) {
    case 'select':
      return (
        <FilterSelect
          config={config}
          value={value as string | null}
          onChange={onChange}
          compact={compact}
        />
      );

    case 'multiselect':
      return (
        <FilterMultiSelect
          config={config}
          value={(value as string[]) || []}
          onChange={onChange}
          compact={compact}
        />
      );

    case 'search':
      return (
        <FilterSearch
          config={config}
          value={(value as string) || ''}
          onChange={onChange}
          compact={compact}
        />
      );

    case 'dateRange':
      return (
        <FilterDateRange
          config={config}
          value={value as DateRangeValue | null}
          onChange={onChange}
          compact={compact}
        />
      );

    case 'numberRange':
      return (
        <FilterNumberRange
          config={config}
          value={value as NumberRangeValue | null}
          onChange={onChange}
          compact={compact}
        />
      );

    case 'boolean':
      return (
        <FilterBoolean
          config={config}
          value={value as boolean | null}
          onChange={onChange}
          compact={compact}
        />
      );

    default:
      return <div>Bilinmeyen filtre tipi: {config.type}</div>;
  }
}

export const FilterItem = memo(FilterItemComponent);
